import LiveEvent from "../interface/LiveEvent";

export default function addIntree(
  event: LiveEvent,
  tree,
  treeGroup: string[],
  resolve,
  callback,
  modifier,
  itemPosition = 0
) {
  const dataIndex = treeGroup[itemPosition];
  const value = event[dataIndex];
  const isRoot = itemPosition == 0;
  const isLeaf = treeGroup.length == itemPosition + 1;
    
    const childrens = resolve({
      event,
      tree,
      value,
      dataIndex,
      isRoot,
      isLeaf,
      modifier,
      itemPosition
    });
    if (itemPosition < treeGroup.length - 1) {
      addIntree(
        event,
        childrens,
        treeGroup,
        resolve,
        callback,
        modifier,
        itemPosition + 1
      );
    }
    return callback({ tree, childrens, isRoot, isLeaf });
  
}
